import React, { use, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../router/all_routes'
import CollapseHeader from '../../../core/common/collapse-header/collapse-header'
import PredefinedDateRanges from '../../../core/common/datePicker'
import Table from "../../../core/common/dataTable/index";
// import { leadsDataList } from '../../../core/data/json/leadsList'
// import CrmsModal from '../../../core/modals/crms_modal'
import { leadsDataList } from '../../../core/data/json/leadsList'
import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod'
import { webServiceUrl } from '../../../core/api_utils/webserviceUrl'
import '../../../core/common/loader/index';
import CustomeLoader from '../../../core/common/customeLoader/CustomeLoader'
import Loading from '../../../core/common/custom-loading/Loading'
const SalesTeam = () => {
  const navigate = useNavigate();
  const routes = all_routes;
  // const data = leadsDataList;

  const [team, setTeam] = useState<any[]>([]);
  const [loading, setLoading] = useState(false)
  // console.log("nananamyarjun122", team)

  const organizationId = localStorage.getItem("organization_id")
  // console.log("this is ogranization id is here", organizationId)

  const SalesTeamData = async () => {
    const payload = {
      "organization_id": organizationId
    }
    try {
      setLoading(true)
      const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.SALES_TEAM, payload)
      // console.log(response?.data, "anajanjsdfasdfasdfasdfa mannu")
      // setTeam(response?.data[0])
      setTeam(response?.data || []);
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }


  useEffect(() => {
    SalesTeamData()
  }, [])


  const  columns = [
      {

        title: "Employee ID",
        dataIndex: "employee_id",
        sorter: (a: any, b: any) => a.employee_id.length - b.employee_id.length,
      },
      {
        title: "Name",
        dataIndex: "full_name",
        render: (text: string)=>text?.trim () ? text : "-",
        sorter: (a: any, b: any) => a.full_name.length - b.full_name.length,
      },


      {
        title: "Mobile No",
        dataIndex: "mobile_no",
        render:(text: string)=> text?.trim() ? text : "-",
        sorter: (a: any, b: any) => a.mobile_no.length - b.mobile_no.length,
      },
      {
        title: "Email",
        dataIndex: "email_id",
        render:(text: string)=> text?.trim() ? text : "-",
        sorter: (a: any, b: any) => a.email_id.length - b.email_id.length,
      },

      {
        title: "View Leads",
        dataIndex: "FollowupTrail",
        width: 150, // Set width in pixels (adjust as needed)
        // sorter: (a: any, b: any) => a.FollowupTrail.length - b.FollowupTrail.length,
        render: (_: any, record: any) => {
          return (
            <button
              onClick={() => {
                console.log("my id is jhai", record.employee_id)
                navigate('/sales-person-lead-list', { state: { employeeId: record.employee_id } });
              }}
              className="btn btn-sm w-50"
              style={{ whiteSpace: 'nowrap', background: "#6b7280", color: "white" }}
            >
              View
            </button>

          );
        },
      }

    ]

    
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Sales Teams </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item"> <Link to={routes.leaddashboard}>
                    Dashboard
                  </Link></li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Sales Team
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="d-flex align-items-center  p-0 me-auto">
                  {/* <Link
                    to={`/add-staff`}
                    className="btn btn-sm me-1"
                    style={{ whiteSpace: 'nowrap', background: '#014d4e', color: 'white' }}
                  >
                    Add Staff
                  </Link> */}

                  {/* <Link to={routes.leadsGrid} className="btn btn-icon btn-sm">
                <i className="ti ti-layout-grid" />
              </Link> */}
                </div>
              </div>


              {/* <div className="me-2 mb-2">
            <div className="dropdown">
              <Link
                to="#"
                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i className="ti ti-file-export me-1" />
                Export
              </Link>
              <ul className="dropdown-menu  dropdown-menu-end p-3">
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    <i className="ti ti-file-type-pdf me-1" />
                    Export as PDF
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    <i className="ti ti-file-type-xls me-1" />
                    Export as Excel{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div> */}
              {/* <div className="mb-2">
            <Link
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#add_leads"
              className="btn btn-primary d-flex align-items-center"
            >
              <i className="ti ti-circle-plus me-2" />
              Add Lead
            </Link>
          </div> */}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Leads List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5> Sales Team  </h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  {/* <div className="input-icon-end position-relative">
                    <PredefinedDateRanges />
                    <span className="input-icon-addon">
                      <i className="ti ti-chevron-down" />
                    </span>
                  </div> */}
                </div>
                {/* <div className="dropdown me-3">
              <Link
                to="#"
                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Tags
              </Link>
              <ul className="dropdown-menu  dropdown-menu-end p-3">
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Closed
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Contacted
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Lost
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Not Contacted
                  </Link>
                </li>
              </ul>
            </div> */}
                {/* <div className="dropdown">
              <Link
                to="#"
                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : Last 7 Days
              </Link>
              <ul className="dropdown-menu  dropdown-menu-end p-3">
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Recently Added
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Ascending
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Desending
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Last Month
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Last 7 Days
                  </Link>
                </li>
              </ul>
            </div> */}
              </div>
            </div>
            {
              loading ? (
                <Loading />
              ) : (
                <div className="card-body p-0">
                  <Table dataSource={team} columns={columns} Selection={false} />
                </div>
              )
            }
          </div>
          {/* /Leads List */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">{new Date().getFullYear()} © Nestfin Technology. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* <CrmsModal/> */}
    </>

  )
}

export default SalesTeam